<template>
  <div class="create">
    <div class="block">
      <van-cell-group>
        <van-cell
          title="创建告知书"
          style="
            color: rgba(153, 159, 164, 100);
            font-family: SourceHanSansSC-bold;
          "
        />
        <van-field
          label-class="label"
          v-model="data.customerName"
          label="客户姓名"
          required
          placeholder="请输入客户姓名"
          input-align="right"
          :rules="[{ name, message: '请输入正确姓名' }]"
        />
        <van-field
          label-class="label"
          v-model="data.mobile"
          label="手机号"
          placeholder="请输入手机号"
          type="tel"
          required
          input-align="right"
          :rules="[{ pattern, message: '请输入正确手机号' }]"
          border
        />
        <van-field
          label-class="label"
          v-model="data.idNo"
          label="身份证号码"
          required
          placeholder="请输入身份证号码"
          input-align="right"
          :rules="[{ idcard, message: '请输入正确身份证号' }]"
        />
        <van-cell
          title="产品名称"
          :value="data.title ? data.title : '请输入产品'"
          required
          to="/noticesearch"
          :value-class="data.title ? 'value' : ''"
        />
        <van-cell
          title="保险公司"
          :value="data.company"
          required
          value-class="value"
        />
        <van-cell title="客户告知书" @click="getpdf">
          <span class="pdf">预览</span>
        </van-cell>
      </van-cell-group>
      <van-button
        type="primary"
        block
        color="#31D5BF"
        round
        class="keep"
        @click="keep"
        >保存</van-button
      >
    </div>
  </div>
</template>
<script>
import { addnotice, noticepreview } from "../../api/notice";
import { loading,isAndroid } from "../../utils/index";
import { isvalidPhone, validateIdNo,isName } from "@/utils/validate";
export default {
  data() {
    return {
      data: {
        customerName: "",
        title: "",
        company: "",
        idNo: "",
        mobile: "",
        companyId: "",
        productId: "",
      },
      pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
      idcard: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
      userId: "",
      pdffile: "",
      name:/[\u4e00-\u9fa5]{2,7}/,
      keepalive:true
    };
  },
  methods: {
    keep() {
      let { customerName, idNo, mobile, companyId, productId } = this.data;
      console.log(isName(customerName))
      if (!isName(customerName)) {
        this.Toast("请正确填写客户姓名");
        return;
      } else if (!productId) {
        this.Toast("请填写产品及公司名称");
        return;
      } else if (!isvalidPhone(mobile)) {
        this.Toast("请输入正确的手机号码");
        return;
      } else if (!validateIdNo(idNo)) {
        this.Toast("请输入正确的身份证号码");
        return;
      }
      let data = {
        customerName,
        idNo,
        mobile,
        companyId,
        productId,
        userId: this.userId,
      };
      loading(true);
      addnotice(data).then((res) => {
        console.log(res);
        loading(false);
        this.Toast("创建成功");
        this.data = {
          customerName: "",
          title: "",
          company: "",
          idNo: "",
          mobile: "",
          companyId: "",
          productId: "",
        };
        console.log(222);
        this.keepalive=false
        sessionStorage.setItem('update',1)//初始化缓存
         sessionStorage.setItem("cansign",1)//关闭签字保存按钮
        this.$router.push({path:'/unsign',query:{id:res.id,userId:this.userId}})
        // this.$router.go(-1);
      });
    },
    getpdf() {
      if (this.pdffile) {
        if (isAndroid()) {
          this.$router.push({ path: "/pdf2", query: { file: this.pdffile } });
        } else {
          window.open(this.pdffile);
        }
      } else {
        let { companyId, productId } = this.data;
        let data = {
          companyId,
          productId,
        };
        if (!productId) {
          this.Toast("请填写产品及公司名称");
          return;
        }
        loading(true);
        noticepreview(data).then((res) => {
          console.log(res);
          loading(false);
          this.pdffile = res;
          if (isAndroid()) {
            this.$router.push({ path: "/pdf2", query: { file:res } });
          } else {
            window.open(res);
          }
          // this.$router.push({ path: "/pdf2", query: { file: res } });
        });
      }
    },
  },
  activated() {
    let text = sessionStorage.getItem("proditem");//选择产品
    if (text) {
      let { id, companyId, company, productName } = JSON.parse(text);
      this.data.productId = id;
      this.data.companyId = companyId;
      this.data.title = productName;
      this.data.company = company;
      sessionStorage.removeItem("proditem");
    }
  },
  mounted() {
    this.userId = this.$route.query.userId;
  },
  // beforeRouteLeave (to, from, next) {
  //   console.log(to)
  //   if(this.keepalive==false){
  //      to.meta.keepAlive=false
  //   }else if(to.name=='notice'){
  //      to.meta.keepAlive=true
  //   }
   
  //   next()
  // }
};
</script>
<style lang="less" >
.create {
  width: 100%;
  height: 100vh;
  .label {
    color: rgba(16, 16, 16, 100) !important;
    font-size: 14px;
    text-align: left;
    font-family: SourceHanSansSC-regular;
  }
  .value {
    color: rgba(16, 16, 16, 100) !important;
    font-size: 14px;
    text-align: right;
    font-family: SourceHanSansSC-regular;
  }
  .block {
    width: 358px;
    margin: 19px auto;
    background: #fff;
    padding-bottom: 14px;
    .pdf {
      color: rgba(51, 153, 255, 100);
      font-size: 14px;
      text-align: right;
      font-family: SourceHanSansSC-regular;
    }
    .keep {
      height: 40px;
      margin: 14px auto;
      width: 338px;
    }
    .myitem {
      height: 80px;
      overflow-y: auto;
    }
  }
}
</style>